import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';

/**
 * @function
 * Determine if this configuration option group is valid.
 * Must have at least one option
 * @param {IConfigurationOptionGroup} group
 */
export const isValid = (group: IConfigurationOptionGroup) => {
  const { packs: options } = group;
  return options && options.length > 0;
}

/**
 * @function
 * Determine if this configuration option group has multiple options
 * @param {IConfigurationOptionGroup} group
 */
export const hasMultipleOptions = (group: IConfigurationOptionGroup) => {
  const { packs: options } = group;
  return options && options.length > 1;
}

/**
 * @function
 * Determine if this configuration option group is associated with EIM.
 * An EIM option has a numeric prefix followed by - for name
 * @param {IConfigurationOptionGroup} group
 */
export const isPartOfEim = (group: IConfigurationOptionGroup) => {
  const { name } = group;
  if (!name) {
    return false;
  }
  const index = name.indexOf('-');
  if (index < 0) {
    return false;
  }
  return !isNaN(parseInt(name.substring(0, index).trim(), 10));
}
